module.exports = __webpack_public_path__ + "img/lec.4c53dae8.svg";